import React from "react";
import { Typography } from "@mui/material";
import { useTheme } from "../../util/themes";

interface HelperInputTextProps {
    text: any;
    error?: boolean;
}

function HelperInputText(props: HelperInputTextProps) {
    const theme = useTheme();

    return (
        <Typography
            ml={1}
            variant="subtitle2"
            sx={{
                marginLeft: "14px",
                fontStyle: props.error ? "normal" : "italic",
                fontWeight: props.error ? 700 : 400,
                fontSize: props.error ? "0.8125rem" : "0.75rem",
                color: props.error ? "#D32F2F" : theme.colors.text.secondary,
            }}
        >
            {props.text}
        </Typography>
    );
}

export default HelperInputText;
